import { FC } from 'react';
import { Drawer, Form, Input, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'shared/config/store/store';
import { useMessage } from 'shared/libs/hooks/useMessage/useMessage';
import { useCreatePlanAccountMutation } from 'entities/account/api';
import { setActivity } from 'shared/config/store/reducers/appSlice';
import { ApiError } from 'shared/model/types';
import { EMI } from 'shared/model/types';

type Props = {
  open: boolean;
  onClose: () => void;
  emi: EMI;
};

export const AddAccountDrawer: FC<Props> = ({ open, onClose, emi }) => {
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { showError, showSuccess } = useMessage();
  const [createPlanAccount] = useCreatePlanAccountMutation();

  const onAdd = async (account: string) => {
    dispatch(setActivity(true));
    await createPlanAccount({ emi, title: account })
      .unwrap()
      .then(() => {
        showSuccess(t({ id: 'account.addAccount.messages.success' }));
        form.resetFields();
      })
      .catch((err: ApiError) => {
        const error = err.data.errors?.[0];

        if (error && error.id === 'river.account.error')
          showError(t({ id: 'account.addAccount.messages.limit' }));
        else showError(t({ id: 'account.addAccount.messages.failed' }));
      })
      .finally(() => {
        dispatch(setActivity(false));
      });
  };

  return (
    <Drawer
      closeIcon={<CloseOutlined />}
      title={t({ id: 'demo.button.openAccount' })}
      placement='right'
      width={512}
      onClose={onClose}
      open={open}
      style={{ zIndex: '99999' }}
    >
      <Form
        onFinish={(e) => onAdd(e.account)}
        form={form}
        validateTrigger='onChange'
        style={{
          width: '100%',
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          gap: 16,
          alignItems: 'center',
          marginTop: 50
        }}
      >
        <Form.Item
          style={{ width: '100%' }}
          rules={[{ required: true, message: t({ id: 'river.views.plan.addAccount' }) }]}
          name='account'
        >
          <Input
            style={{ marginBottom: 32 }}
            placeholder={t({ id: 'river.views.plan.addAccount' })}
          />
        </Form.Item>
        <Button onClick={form.submit} type='primary' block>
          {t({ id: 'river.views.plan.addAccount' })}
        </Button>
      </Form>
    </Drawer>
  );
};
